import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { colors, gaps, lineHeight, paddings } from '@ohgoodlord/design-system'
import styled from 'styled-components'
import { track } from '../../../../../common/utils'

export const HEADING_ID = 'overlay-heading'

const StyledOverlayClose = styled.button`
  position: relative;
  background: none;
  border: none;
  top: 0;
  right: 0;
  font-size: 30px;
  cursor: pointer;
  z-index: 1002;
`

const StyledHeader = styled.div<{ $isMobile: boolean }>`
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  gap: ${gaps.s};
  align-items: center;
  text-align: left;
  height: auto;
  background-color: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  padding: ${paddings.m};
  z-index: 99;
  h1 {
    text-align: left;
    font-family: Lexend Deca;
    font-weight: 600;
    font-size: ${({ $isMobile }) => ($isMobile ? '18px' : '24px')};
    color: ${colors.textPrimary};
    line-height: ${lineHeight};
  }
`

export interface Props {
  modal: string
  isMobile: boolean
  title?: string
  onClose: () => void
}

export const DefaultHeader = ({ modal, isMobile = false, title, onClose }: Props) => (
  <StyledHeader $isMobile={isMobile}>
    <StyledOverlayClose
      type="button"
      aria-label="close overlay"
      onClick={() => {
        track('Click - Close Overlay', { modal })
        onClose()
      }}
    >
      <FontAwesomeIcon icon="close" />
    </StyledOverlayClose>
    {title && (
      <div>
        <h1 id={HEADING_ID}>{title}</h1>
      </div>
    )}
  </StyledHeader>
)
